const prefix = '/ticketing';

export const routes = {
  DETAILS: `${prefix}/details`,
  INDEX: prefix,
  LIST: `${prefix}/list`,
  TERMINATION_STEP: `${prefix}/termination`,
  TERMINATION_DETAILS: `${prefix}/details/termination`,
};
